import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { TitleCasePipe, CommonModule } from '@angular/common';
import { DialogComponent } from 'src/app/@core/components/ui/dialog/dialog.component';
import { FileDropComponent } from '../components/file-drop/file-drop.component';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from "../../@core/components/ui/button/button.component";
import { SelectOption } from "../../@core/components/ui/select";

export enum UPLOAD_TYPE {
  UPDATE = 'UPDATE',
  CREATE = 'CREATE'
}

@Component({
  selector: 'app-excel-upload-dialog',
  standalone: true,
  imports: [CommonModule, DialogComponent, FileDropComponent, ButtonModule, FormsModule, TitleCasePipe, ButtonComponent],
  templateUrl: './excel-upload-dialog.component.html',
  styleUrl: './excel-upload-dialog.component.scss'
})


export class ExcelUploadDialogComponent {

  @Input() visible: boolean = false
  @Input() maxFileSize: number = 10 * 1000 * 1000
  @Input() downloadExistingExcelData: boolean = false
  @Input() showUploadOptions: boolean = false
  @Output() downloadSampleExcelClicked = new EventEmitter<void>();
  @Output() downloadExistingExcelClicked = new EventEmitter<void>();
  @Output() onDialogClose = new EventEmitter<void>();
  @Output() onExcelUpload = new EventEmitter<{
    file: File,
    type: UPLOAD_TYPE
  }>();

  dragAreaClass: string = '';
  fileTypes: string[] = ['.xls', '.xlsx']
  uploadedFile: File | null = null;
  uploadOptions: SelectOption[] = [
    { label: 'Create', value: UPLOAD_TYPE.CREATE },
    { label: 'Update', value: UPLOAD_TYPE.UPDATE }
  ];

  selectedType = UPLOAD_TYPE.CREATE;

  selectUploadType(type: UPLOAD_TYPE) {
    this.selectedType = type;
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    this.dragAreaClass = 'droparea';
    event.preventDefault();
  }

  @HostListener('dragenter', ['$event'])
  onDragEnter(event: DragEvent) {
    this.dragAreaClass = 'droparea';
    event.preventDefault();
  }

  @HostListener('dragend', ['$event'])
  onDragEnd(event: DragEvent) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent) {
    this.dragAreaClass = 'dragarea';
    event.preventDefault();
    event.stopPropagation();

    // if (event.dataTransfer?.files) {
    //   const files: FileList = event.dataTransfer.files;
    //   if (files.length > 0) {
    //     this.fileName = files[0].name;
    //     this.isFileAdded = true;

    //   }
    // }
  }

  downloadSampleExcel() {
    this.downloadSampleExcelClicked.emit()
  }

  downloadExistingExcel() {
    this.downloadExistingExcelClicked.emit()
  }

  dialogClosed() {
    this.uploadedFile = null;
    this.onDialogClose.emit()
  }

  onFileUploaded(event: File | File[]) {
    event = event as File[]
    if (event.length) {
      this.uploadedFile = event[0]
    }
    else {
      this.uploadedFile = null;
    }
  }

  onFileRemove(file: File) {
    this.uploadedFile = null;
  }

  onSubmit() {
    this.onExcelUpload.emit({
      file: this.uploadedFile as File,
      type: this.selectedType
    })
    this.cancel()
  }

  cancel() {
    this.uploadedFile = null;
    this.visible = false;
    this.onDialogClose.emit()
  }
}
